import React from 'react';

import PromiseRender from './PromiseRender';

import { CURRENT } from './index';
// const CURRENT = 'admin';

function isPromise(obj) {
  return (
    !!obj &&
    (typeof obj === 'object' || typeof obj === 'function') &&
    typeof obj.then === 'function'
  );
}

/**
 * 通用权限检查方法
 * Common check permissions method
 * @param { 权限判定 Permission judgment type string |array | Promise | Function } authority
 * @param { 你的权限 Your permission description  type:string} currentAuthority
 * @param { 通过的组件 Passing components } target
 * @param { 未通过的组件 no pass components } Exception
 */
// authority - 当前检查的权限 ， currentAuthority - 当前用户的所有权限
const checkPermissions = (authority, currentAuthority, target, Exception) => {
  // 由于目前不支持数组形式的多重权限判断（必须每个权限都有），先加入bool类型判断
  // TODO: 会不会和下方的没有设置权限直接返回的状态产生冲突？
  // TODO: 加入多重权限判断
  if (typeof authority === 'boolean') {
    if (authority) return target;
    return Exception;
  }
  // 没有判定权限.默认查看所有
  // Retirement authority, return target;
  if (!authority) {
    return target;
  }
  // 数组处理 - 老，用户当前只有一个身份权限，当匹配到锁需求的权限之一时便通过（来自模板）
  // if (Array.isArray(authority)) {
  //   if (authority.indexOf(currentAuthority) >= 0) {
  //     return target;
  //   }
  //   return Exception;
  // }

  // 数组处理 - 新，用户当前有多个权限项目，当请求的权限与用户身份的权限存在交集时（哪怕只有一个）也通过
  if (Array.isArray(authority)) {
    if (currentAuthority.some(item => authority.includes(item))) {
      return target;
    }
    return Exception;
  }

  // string 处理
  if (typeof authority === 'string') {
    if (authority === currentAuthority || currentAuthority.indexOf(authority) >= 0) {
      return target;
    }
    return Exception;
  }

  // Promise 处理
  if (isPromise(authority)) {
    return <PromiseRender ok={target} error={Exception} promise={authority} />;
  }

  // Function 处理
  if (typeof authority === 'function') {
    try {
      const bool = authority(currentAuthority);
      // 函数执行后返回值是 Promise
      if (isPromise(bool)) {
        return <PromiseRender ok={target} error={Exception} promise={bool} />;
      }
      if (bool) {
        return target;
      }
      return Exception;
    } catch (error) {
      throw error;
    }
  }
  throw new Error('unsupported parameters');
};

export { checkPermissions };

const check = (authority, target, Exception) => {
  return checkPermissions(authority, CURRENT, target, Exception);
};

export default check;
